import { render, staticRenderFns } from "./AttributesTable.vue?vue&type=template&id=5697ae56&scoped=true&"
import script from "./AttributesTable.vue?vue&type=script&lang=js&"
export * from "./AttributesTable.vue?vue&type=script&lang=js&"
import style0 from "./AttributesTable.vue?vue&type=style&index=0&id=5697ae56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5697ae56",
  null
  
)

export default component.exports